import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { SuggestedReceiptDto } from '../types';

export const useTransferReceiptSuggestions = (transferId: string) => {
  const { projectId } = useParams();

  return useQuery<SuggestedReceiptDto[]>({
    queryKey: ['transfer-receipt-suggestions', transferId],
    queryFn: () =>
      apiClient.get(`/v1/projects/${projectId}/transfers/${transferId}/receipt-suggestions`),
    enabled: !!projectId && !!transferId,
  });
};
